import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from 'rxjs';
import { AppService } from "src/app/app.service";
import { PaymentService } from "src/app/services/payment.service";
import { Router } from '@angular/router';
import { MatDialog } from "@angular/material/dialog";
import { TransferCreateComponent } from "../transfer-create/transfer-create.component";
import { TransferService } from "src/app/services/transfer.service";
import { AuthService } from "src/app/services/auth.service";
import { NumeroCompteService } from "src/app/services/numero-compte.service";
import { NumeroCompte } from "src/app/app.models";



@Component({
  selector: "app-mes-revenus",
  templateUrl: "./mes-revenus.component.html",
  styleUrls: ["./mes-revenus.component.scss"],
})
export class MesRevenusComponent implements OnInit, OnDestroy {

  //Subscription
  sumIncome: Subscription;
  sumTransfer: Subscription;
  currentAmountSubscription: Subscription;
  amountOutstandingSubscription: Subscription;
  numeroCompteSubscription: Subscription;

  sumGetted: boolean;
  sumTransferGetted: boolean;
  currentAmountGetted: boolean;
  amountOutstandingGetted: boolean;

  public numeroCompte: NumeroCompte

  public user: any;
  customerList: any;
  resultcat: any;

  revenuetotal: number;
  transferTotal: number;
  currentAmount: number;
  amountOutstanding: number;
  
  //outPut
  valueChange: boolean;

  currency: string;


  constructor(
    public appService: AppService,
    public paymentService: PaymentService,
    public router: Router,
    public dialog: MatDialog,
    public transferService: TransferService,
    private authService: AuthService,
    private numeroCompteService: NumeroCompteService
  ) {}

  ngOnInit(): void {
    
    this.initProperty();

  }

  private initProperty() {

    this.currency = this.appService.getCurrency();
    
    let res = this.authService.getUserOfLocalStorage();
    
    if(res.status) {

      this.user = JSON.parse(localStorage.getItem("user")!)

      let obj = {

        'idUser': this.user.id,
        'key': 'RENTING'

      }

      //Total revenus
      this.sumIncome =  this.paymentService.sumIncome(obj).subscribe((data: any) => {
          
        this.revenuetotal = data.value;

        this.sumGetted = true;

        // console.log(this.revenuetotal, data);

      });
      

      //Total virements
      this.sumTransfer = this.transferService.sumTransfer(obj).subscribe((data: any) => {

        this.transferTotal = data.value;

        this.sumTransferGetted = true;
        
      })


      //Montant actuel
      this.currentAmountSubscription = this.paymentService.currentAmount(obj).subscribe((data: any) => {
        this.currentAmount = data.value;
        this.currentAmountGetted = true;
      })


      //Montant encours des virements
      this.amountOutstandingSubscription = this.paymentService.amountOutstanding(obj).subscribe((data: any) => {

        this.amountOutstanding = data.value;
        this.amountOutstandingGetted = true;

      })


      //Numéro de compte de l'utilisateur
      this.numeroCompteSubscription = this.numeroCompteService.numeroCompteOfUser(this.user.id).subscribe((response: any) => {
  
       
        if(response.numeroCompte) {
  
          this.numeroCompte = response.numeroCompte;
  
        } else {
  
          this.numeroCompte = new NumeroCompte({});
  
        }

        // console.log(response, this.numeroCompte);
    
      })

    } else {

      this.sumGetted = false;
      this.sumTransferGetted = false;
      this.currentAmountGetted = false;
      this.router.navigate(['login']);
    }

    this.valueChange = false;

  }


  /**
   * Enregistrement d'une demande de virement
   */
  public createTransfer() {

    let data = {
      amount: this.currentAmount,
      idUser: this.user.id,
      key: 'RENTING'
    } 

    const dialogRef = this.appService.openDialog(TransferCreateComponent, data, 'theme-dialog');

    dialogRef.afterClosed().subscribe((res) => {
      
      this.initProperty();

      this.valueChange = true;

    })
    // this.dialog.open(TransferCreateComponent); 

  }

  ngOnDestroy(): void {
    
    if(this.sumGetted) {

      this.sumIncome.unsubscribe();

    }

    if(this.sumTransferGetted) {

      this.sumTransfer.unsubscribe();

      this.numeroCompteSubscription.unsubscribe();

    }

    if(this.currentAmountGetted) {

      this.currentAmountSubscription.unsubscribe();

    }

    if(this.amountOutstandingGetted) {

      this.amountOutstandingSubscription.unsubscribe();
      
    }
    
  }

}
